import { ProLabelMappingProfile } from "./pro-label-mapping-profile";

export class ProMappedHeaders {
    //proMappedHeadersProfile: ProLabelMappingProfile = new ProLabelMappingProfile();
    mappedFrom: string = '';
    mappedTo: string = '';

    static mapProperties(item: any): ProMappedHeaders {
        return {
            mappedFrom: item.mapped_from,
            mappedTo: item.mapped_to
        };
    }
}
